package com.milta.feature.auth.data.remote.dto

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

/**
 * MIL-22 — mirrors the backend's `SubscriptionAccessScope` enum (see
 * `Milta.Application.Common.SubscriptionAccessScope`). Carried in `ApiError.scope` when
 * `code == "error.subscription_expired"`.
 */
@Serializable
enum class SubscriptionAccessScope {
    @SerialName("Own") OWN,
    @SerialName("Organization") ORGANIZATION,
}
